import MUIAccordionSummary, { AccordionSummaryProps } from "@mui/material/AccordionSummary";
import React, { FC } from "react";

export const AccordionSummary: FC<AccordionSummaryProps> = (props) => <MUIAccordionSummary {...props} />;
